import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  className = 'h-4 w-4'
}: {
  className?: string;
}) {
  return <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-275" data-mp="3gpcpu95etf41">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className={`${className} fill-sun text-sun`} aria-hidden="true" data-id="element-276" data-mp="3kotu4z93o67m" />)}
    </div>;
}